import { render, staticRenderFns } from "./StatsPlateLab.vue?vue&type=template&id=bcc4fea6&scoped=true"
import script from "./StatsPlateLab.vue?vue&type=script&lang=js"
export * from "./StatsPlateLab.vue?vue&type=script&lang=js"
import style0 from "./StatsPlateLab.vue?vue&type=style&index=0&id=bcc4fea6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc4fea6",
  null
  
)

export default component.exports